

if( ! window.sctCached ) {
    window.sctCached = new Map();
}

export function addCachedItem(key, value) {
    window.sctCached.set(key, value);
}

export function getCachedItem(key) {
    return window.sctCached.get(key);

}

export function deleteCachedItem(key) {
    window.sctCached.set(key, null);
}

export function clearAllCachedItem() {
    window.sctCached = new Map();
}

